import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DatePickerModalComponent extends Vue {
	@Prop({ type: Number, required: true })
	public currentYear!: number;

	@Prop({ type: Boolean, required: false, default: false })
	public isYear!: boolean;

	public selectedYear: Date = new Date();

	public monthList: string[] = [
		"Jan",
		"Fev",
		"Mar",
		"Avr",
		"Mai",
		"Jun",
		"Jul",
		"Aou",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	];

	public mounted(): void {
		this.selectedYear = new Date(this.currentYear, 0);
		document.addEventListener("click", this.handleClickOutside);
	}

	public destroyed(): void {
		document.removeEventListener("click", this.handleClickOutside);
	}

	public selectMonth(monthIndex: number): void {
		this.selectedYear.setMonth(monthIndex);
		this.$emit("selectedDate", this.selectedYear);
	}

	public changeSelectedYear(add: boolean): void {
		const newYear = new Date(this.selectedYear);

		if (this.isYear) {
			newYear.setFullYear(newYear.getFullYear() + (add ? 12 : -12));
		} else {
			newYear.setFullYear(newYear.getFullYear() + (add ? 1 : -1));
		}

		this.selectedYear = newYear;
	}

	private handleClickOutside(event: MouseEvent): void {
		const modalElement = this.$refs.datePickerModal as HTMLElement;
		if (modalElement && !modalElement.contains(event.target as Node)) {
			this.$emit("closeModal");
		}
	}

	public yearList(): number[] {
		const yearList: number[] = [];

		for (let i = 0; i < 12; i += 1) {
			yearList.push(this.selectedYear.getFullYear() + i);
		}

		return yearList;
	}

	public selectYear(year: number): void {
		this.$emit("selectedYear", year);
	}
}



// WEBPACK FOOTER //
// ./src/components/calendrier/datePickerModal/datePickerModal.ts